import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c41b61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-section" }
const _hoisted_2 = { class: "help-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "🎯 이게 뭐하는 건가요?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "생산직비과세"),
    /*#__PURE__*/_createTextVNode("를 적용하면 기관이 내야 할 4대보험료와 퇴직금이 줄어듭니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 이 표는 \"적용 전\"과 \"적용 후\"를 비교해서 "),
    /*#__PURE__*/_createElementVNode("strong", null, "얼마나 절감되는지"),
    /*#__PURE__*/_createTextVNode(" 보여줍니다. ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "📊 개선전 vs 개선후"),
  /*#__PURE__*/_createElementVNode("table", { class: "help-table" }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th"),
      /*#__PURE__*/_createElementVNode("th", null, "개선전"),
      /*#__PURE__*/_createElementVNode("th", null, "개선후")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "생산직비과세"),
      /*#__PURE__*/_createElementVNode("td", { class: "red" }, "❌ 미적용"),
      /*#__PURE__*/_createElementVNode("td", { class: "green" }, "✅ 적용")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "비과세 항목"),
      /*#__PURE__*/_createElementVNode("td", null, "당직+중식+차량+양육만"),
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createTextVNode("당직+중식+차량+양육 "),
        /*#__PURE__*/_createElementVNode("strong", null, "+ 연장야간휴일수당")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "과세금액"),
      /*#__PURE__*/_createElementVNode("td", { class: "red" }, "더 많음"),
      /*#__PURE__*/_createElementVNode("td", { class: "green" }, "더 적음")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "기관부담 보험료"),
      /*#__PURE__*/_createElementVNode("td", { class: "red" }, "더 많이 냄"),
      /*#__PURE__*/_createElementVNode("td", { class: "green" }, "더 적게 냄")
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "🧮 계산 방법"),
  /*#__PURE__*/_createElementVNode("div", { class: "calc-item" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "1. 비과세 합계"),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-formula" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "개선전:"),
      /*#__PURE__*/_createTextVNode(" 당직수당 + 중식대 + 차량비 + 양육비 ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-formula" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "개선후:"),
      /*#__PURE__*/_createTextVNode(" 당직수당 + 중식대 + 차량비 + 양육비 + "),
      /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "생산직비과세(연장야간휴일수당)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "calc-item" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "2. 기관부담 4대보험"),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-formula" }, " 과세금액을 기준으로 계산 (과세금액 ↑ = 보험료 ↑) "),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-detail" }, [
      /*#__PURE__*/_createTextVNode(" • 건강보험 = 과세금액 × 건강보험요율"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 장기요양 = 건강보험 × 장기요양요율"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 고용보험 = 과세금액 × 고용보험요율"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 실업급여 = 과세금액 × 실업급여요율"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 국민연금 = "),
      /*#__PURE__*/_createElementVNode("span", { class: "note" }, "개선후와 동일값 사용 (별도 신고 기준)"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 산재보험 = "),
      /*#__PURE__*/_createElementVNode("span", { class: "note" }, "개선후와 동일값 사용 (사업장 기준)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "calc-item" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "3. 퇴직금"),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-formula" }, " (총급여 - 중식대) ÷ 12 "),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-detail" }, " • 중식대는 퇴직금 산정 기준에서 제외됩니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "calc-item" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "4. 기관 절감액"),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-formula highlight-box" }, " 절감액 = 기관부담 차액 + 퇴직금 차액 "),
    /*#__PURE__*/_createElementVNode("div", { class: "calc-detail" }, [
      /*#__PURE__*/_createTextVNode(" • 마이너스(-) 값 = 💰 절감 (좋은 것!)"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • 플러스(+) 값 = 증가 (나쁜 것) ")
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-box info-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "📅 서비스 시작연월 & 제외 대상"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "조회연월:"),
      /*#__PURE__*/_createTextVNode(" 현재 비교 분석 중인 연월")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "서비스 시작연월:"),
      /*#__PURE__*/_createTextVNode(" 우리 기관이 임금서비스를 시작한 연월 (수정 가능)")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "제외 대상:"),
      /*#__PURE__*/_createTextVNode(" 서비스 시작연월 "),
      /*#__PURE__*/_createElementVNode("span", { class: "red" }, "이전에 퇴사"),
      /*#__PURE__*/_createTextVNode("한 직원은 비교분석에서 제외됩니다.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-detail" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "예시)"),
    /*#__PURE__*/_createTextVNode(" 서비스 시작 2026년 4월"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" • 3월 퇴사자 → "),
    /*#__PURE__*/_createElementVNode("span", { class: "red" }, "제외"),
    /*#__PURE__*/_createTextVNode(" (서비스 시작 전 퇴사)"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" • 4월 퇴사자 → "),
    /*#__PURE__*/_createElementVNode("span", { class: "green" }, "포함"),
    /*#__PURE__*/_createTextVNode(" (서비스 시작 이후 퇴사)"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" • 5월 퇴사자 → "),
    /*#__PURE__*/_createElementVNode("span", { class: "green" }, "포함")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "info-detail",
    style: {"margin-top":"8px"}
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, "📋 임금대장:"),
    /*#__PURE__*/_createTextVNode(" 퇴사연월이 자동 감지되어 제외됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "📤 임금엑셀업로드:"),
    /*#__PURE__*/_createTextVNode(" 제외 열의 "),
    /*#__PURE__*/_createElementVNode("span", { class: "checkbox-icon" }, "☑"),
    /*#__PURE__*/_createTextVNode(" 체크박스로 직접 선택하세요. ")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-box tip-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "💡 알아두세요"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "적용 대상:"),
      /*#__PURE__*/_createTextVNode(" 요양보호사, 조리사, 조리원 (비과세 적용 가능)")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "비과세 한도:"),
      /*#__PURE__*/_createTextVNode(" 연장·야간·휴일 수당 중 월 240만원까지")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "차액이 마이너스면:"),
      /*#__PURE__*/_createTextVNode(" 기관이 절감하는 금액입니다!")
    ])
  ])
], -1))
const _hoisted_8 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WageBeforeAfterHelp',
  setup(__props) {

const showHelp = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      variant: "text",
      color: "grey",
      size: "small",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showHelp.value = !showHelp.value)),
      class: "help-toggle-btn"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(showHelp.value ? 'mdi-chevron-up' : 'mdi-help-circle-outline'), 1)
          ]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(showHelp.value ? '도움말 접기' : '계산방식 도움말'), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_8, 512), [
          [_vShow, showHelp.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})